<template>
  <Layout>
    <PageTitle />

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <ChangePassword />
      </div>
      <div class="col-xs-12 col-sm-6">
        <Sessions />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import ChangePassword from './ChangePassword.vue'
import Sessions from './Sessions.vue'

export default {
  components: {
    Layout,
    PageTitle: () => import('./PageTitle.vue'),
    ChangePassword,
    Sessions,
  },
}
</script>
